import { Fragment, useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { SignProgress } from "../components/SignProgress";
import {
  convertInvoice,
  downloadInvoicePdf,
  downloadInvoiceXML,
} from "../../service/InvoiceService";
import { ProgressSpinner } from "primereact/progressspinner";
import { download } from "../../utils/download";

export const HoaDon = (props) => {
  const [clientId, setClientId] = useState("");
  const [displayConvertDialog, setDisplayConvertDialog] = useState(false);
  const [name, setName] = useState("");
  const [displaySignProgress, setDisplaySignProgress] = useState(0);
  const [version, setVersion] = useState(0);
  const [pdfUrl, setPdfUrl] = useState("");
  const [downloadLoading, setDownloadLoading] = useState("");

  useEffect(() => {
    setClientId("" + Date.now() + Math.random() * 1000);
  }, []);

  useEffect(() => {
    if (!props.referenceNumber) {
      return;
    }

    setPdfUrl("");
    downloadInvoicePdf(props.referenceNumber).then((blob) => {
      setPdfUrl(URL.createObjectURL(blob));
    });
  }, [props.referenceNumber]);

  const downloadPdf = () => {
    setDownloadLoading("pdf");
    downloadInvoicePdf(props.referenceNumber).then((blob) => {
      const url = URL.createObjectURL(blob);

      download(
        document,
        url,
        `${props.referenceNumber}_${props.headerInfo.invoiceNo}.pdf`,
      );
      setDownloadLoading("");
    });
  };

  const downloadXml = () => {
    setDownloadLoading("xml");
    downloadInvoiceXML(props.referenceNumber).then((blob) => {
      const url = URL.createObjectURL(blob);
      
      download(
        document,
        url,
        `${props.referenceNumber}_${props.headerInfo.invoiceNo}.xml`,
      );
      setDownloadLoading("");
    });
  };

  const sign = () => {
    window.location.href = `einvoicesign:anonymous,${clientId},invoiceSignedByBuyer,${props.referenceNumber}`;
    setDisplaySignProgress(Date.now);
  };

  const onSignComplete = () => {
    setVersion(Date.now);
  };

  const showConvertDialog = () => {
    setDisplayConvertDialog(true);
  };

  const downloadConvertedInvoice = (event) => {
    event.preventDefault();
    if (name && name.trim()) {
      setDownloadLoading("convert");
      convertInvoice(props.referenceNumber, name).then((blob) => {
        const url = URL.createObjectURL(blob);

        download(
          document,
          url,
          `${props.referenceNumber}_${props.headerInfo.invoiceNo}_${name}.pdf`,
        );
        setDownloadLoading("");
        setDisplayConvertDialog(false);
      });
    }
  };

  return (
    <Fragment>
      {clientId && (
        <SignProgress
          clientId={clientId}
          displaySignProgress={displaySignProgress}
          setDisplaySignProgress={setDisplaySignProgress}
          onSignComplete={onSignComplete}
        />
      )}
      <Dialog
        header="Chuyển đổi hóa đơn"
        visible={displayConvertDialog}
        style={{ width: "400px" }}
        onHide={() => setDisplayConvertDialog(false)}
      >
        <form onSubmit={downloadConvertedInvoice}>
          <div className="grid mt-2">
            <div className="col-12">
              <div className="field p-fluid">
                <label htmlFor="name">Họ và tên người chuyển đổi</label>
                <InputText
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="col-12 text-right">
              <Button
                loading={downloadLoading === "convert"}
                label="Tải xuống"
                icon="pi pi-check"
                type="submit"
                className="p-button-sm mr-2"
              />
              <Button
                label="Đóng"
                icon="pi pi-times"
                type="button"
                onClick={() => setDisplayConvertDialog(false)}
                className="p-button-sm p-button-secondary"
              />
            </div>
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Thông tin hóa đơn"
        visible={!!props.display}
        style={{ width: "100vw", maxWidth: "1200px", height: "90%" }}
        position="top"
        onHide={() => props.setDisplay(0)}
      >
        <div className="grid" style={{ height: "100%" }}>
          <div className="col-fixed w-900">
            {!pdfUrl && (
              <div className="relative w-full h-full">
                <ProgressSpinner strokeWidth="4" className="progress-spinner" />
              </div>
            )}
            {pdfUrl && (
              <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title={props.referenceNumber}
              />
            )}
          </div>
          <div className="col">
            <div className="surface-section">
              <div className="font-medium text-lg mb-3">Thông tin hóa đơn</div>
              <div className="grid border-bottom-1 surface-border text-xs">
                <div className="col-fixed" style={{ width: "138px" }}>
                  Số hóa đơn:
                </div>
                <div className="col text-right">
                  {props.headerInfo["invoiceNo"]}
                </div>
              </div>
              <div className="grid border-bottom-1 surface-border text-xs mt-1">
                <div className="col-fixed" style={{ width: "138px" }}>
                  Tổng tiền thanh toán:
                </div>
                <div className="col text-right">
                  {props.headerInfo["invoiceTotalLocaleString"]}
                </div>
              </div>
              <div className="grid border-bottom-1 surface-border text-xs mt-1">
                <div className="col-fixed" style={{ width: "138px" }}>
                  Hạn thanh toán:
                </div>
                <div className="col text-right">Không có hạn</div>
              </div>
            </div>
            <div className="grid p-fluid mt-5">
              <div className="col-12 pb-0">
                <Button
                  loading={downloadLoading === "pdf"}
                  label="Tải hóa đơn PDF"
                  icon="pi pi-file-pdf"
                  className="p-button-outlined p-button-sm"
                  onClick={downloadPdf}
                />
              </div>
              <div className="col-12 pb-0">
                <Button
                  loading={downloadLoading === "xml"}
                  label="Tải hóa đơn XML"
                  icon="pi pi-download"
                  className="p-button-outlined p-button-sm p-button-secondary"
                  onClick={downloadXml}
                />
              </div>
              <div className="col-12 pb-0">
                <Button
                  label="Chuyển đổi hóa đơn"
                  icon="pi pi-copy"
                  className="p-button-outlined p-button-sm p-button-success"
                  onClick={showConvertDialog}
                />
              </div>
              <div className="col-12">
                <Button
                  label="Ký hóa đơn"
                  icon="pi pi-pencil"
                  className="p-button-outlined p-button-sm p-button-warning"
                  onClick={sign}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};
